import {useState} from "react";
import {BsCheckLg, BsXLg, BsTrash3, BsCheck2Circle} from "react-icons/bs";
import baseUrl from "../../../baseUrl";
import {requester} from "../../../services/requester";
import {useConfirm} from "../../../contexts/ConfirmContext";

// ЧАСТ К — състояние на одобрението върху реда на замяната.
//
// Замяна към ДРУГО землище не влиза в сметките му, докато потребителят на това
// землище не я одобри. Отказът обаче НЕ отменя нищо в землището, където
// замяната е създадена — там тя си остава в сила. Затова поясненито на реда е
// важно: без него след месец редът изглежда като нормална одобрена замяна.

export const rowTint = (status) => {
    switch (status) {
        case 'pending':
            return 'var(--app-pending-bg)';
        case 'rejected':
            return 'var(--app-danger-bg)';
        case 'deleted_far':
            return 'var(--app-neutral-bg)';
        default:
            return undefined;   // approved / not_required — както досега
    }
};

// Кратко пояснение на реда. Текстът е РАЗЛИЧЕН за двете страни: на насрещната
// решението предстои („чака вашето потвърждение"), при автора се съобщава какво
// е станало отсреща.
export const StatusNote = ({status, farSettlementName, isFarSide,
                               rejectedBy, deletedBy, authorAck}) => {
    if (!status || status === 'approved' || status === 'not_required') return null;

    const where = farSettlementName ? `с. ${farSettlementName}` : 'насрещното землище';
    const done = authorAck ? ' (уредено)' : '';

    if (status === 'pending') {
        return (
            <div className="small fst-italic">
                {isFarSide ? 'чака вашето потвърждение' : `чака потвърждение от ${where}`}
            </div>
        );
    }
    if (status === 'rejected') {
        return (
            <div className="small fst-italic" style={{color: "var(--app-danger-fg)"}}>
                {isFarSide
                    ? `отказана от ${rejectedBy || 'вас'} — остава в сила в землището, ` +
                      'където е създадена'
                    : `не е потвърдена в ${where}` +
                      (rejectedBy ? ` — отказана от ${rejectedBy}` : '') + done}
            </div>
        );
    }
    if (status === 'deleted_far') {
        return (
            <div className="small fst-italic" style={{color: "var(--app-danger-fg)"}}>
                {isFarSide
                    ? `изтрита от ${deletedBy || 'вас'}`
                    : `изтрита в ${where}` + (deletedBy ? ` от ${deletedBy}` : '') + done}
            </div>
        );
    }
    return null;
};

// Бутоните. Стоят ПРЕДИ бутона за редакция на същия ред (изрично поискано).
export const ApprovalButtons = ({
                                    dealId,
                                    status,
                                    authorAck,
                                    isFarSide,     // редът се гледа в насрещното землище
                                    isAuthor,      // текущият потребител е създал замяната
                                    onChanged,
                                }) => {
    const request = requester();
    const confirm = useConfirm();
    const [busy, setBusy] = useState(false);

    const call = (path, body) => {
        setBusy(true);
        request.put(`${baseUrl()}/deals/${dealId}/${path}`, body || {})
            .then(() => onChanged())
            .catch(err => alert(err.message || 'Действието не можа да бъде извършено.'))
            .finally(() => setBusy(false));
    };

    const reject = () => {
        const reason = window.prompt(
            'Причина за отказа (по избор — може да се остави празно):', '');
        if (reason === null) return;   // отказ от диалога
        call('reject', {reason});
    };

    const farDelete = async () => {
        // Р7: същият диалог като при всяко друго изтриване.
        if (!await confirm({
            title: "Да излезе ли замяната от вашето землище?",
            message: "Създателят ѝ ще види блед ред „изтрит\" и сам решава дали "
                + "да я махне при себе си.",
            confirmText: "Да, махни я оттук",
        })) return;
        call('delete-far');
    };

    if (isFarSide) {
        return (
            <div className="d-flex gap-1">
                {(status === 'pending' || status === 'rejected') && (
                    <button className="btn btn-success btn-sm" disabled={busy}
                            data-bs-toggle="tooltip" title="Одобрявам"
                            onClick={() => call('approve')}><BsCheckLg/></button>
                )}
                {(status === 'pending' || status === 'approved') && (
                    <button className="btn btn-outline-danger btn-sm" disabled={busy}
                            data-bs-toggle="tooltip" title="Не одобрявам"
                            onClick={reject}><BsXLg/></button>
                )}
                {status === 'approved' && (
                    <button className="btn btn-outline-secondary btn-sm" disabled={busy}
                            data-bs-toggle="tooltip" title="Изтрий от моето землище"
                            onClick={farDelete}><BsTrash3/></button>
                )}
            </div>
        );
    }

    // Страната на автора: единственото действие е „уредено" — гаси
    // сигнализацията, след като се е разбрал с колегата си.
    if (isAuthor && !authorAck && (status === 'rejected' || status === 'deleted_far')) {
        return (
            <button className="btn btn-outline-secondary btn-sm" disabled={busy}
                    data-bs-toggle="tooltip" title="Видях — уредено"
                    onClick={() => call('ack')}><BsCheck2Circle/></button>
        );
    }

    return null;
};
